// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'

// Internal Dependencies:
import Loading from 'components/Loading/Loading'
import Tickets from 'components/Tickets/Tickets'
import RegisterLogin from 'components/RegisterLogin/RegisterLogin'
import { doRequest } from 'utilities/request'

class Home extends React.Component {
	constructor() {
		super()

		this.state = {
			isResending: false,
			isResent: false
		}
	}

	handleClickResend = ( e ) => {
		e.preventDefault()

		this.setState( {
			isResending: true
		} )

		return doRequest( `${siteData.api_base_url}resend-send-activation-email`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true
		} )
			.then( json => {
				this.setState( {
					isResending: false,
					isResent: true
				} )
			} )
			.catch( error => {
				console.error( error.data, 'error' )
			} )
	}

	render() {
		const { requestedAccountData, accountData } = this.props
		const { isResending, isResent } = this.state
		let showTickets = false,
			showRegister = false,
			showVerify = false,
			showLoading = false

		if ( requestedAccountData ) {
			if ( accountData && ! accountData.email_verified ) {
				showVerify = true
			} else if ( accountData ) {
				showTickets = true
			} else {
				showRegister = true
			}
		}

		return (
			<div className="page-home">
				{ showLoading &&
					<Loading />
				}

				{ showVerify &&
					<div className="page-plain">
						<div className="-inner">
							<div className="-content">
								<div className="form-message">
									Please check your email to confirm your address.<br />
									Please check your Junk / Spam.

									{ isResending &&
										<div>
											<br />...
										</div>
									|| isResent &&
										<div>
											<br />The activation email has been resent.
										</div>
									||
										<div>
											<br /><a href="#" onClick={ this.handleClickResend }>Click here to resend.</a>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				}

				{ showRegister &&
					<div className="home-welcome">
						<div className="-inner">
							<div className="-content">
								<h2>Welcome to Comfort Sleep Warranty Registration Portal</h2>
							</div>
						</div>
					</div>
				}

				{ showRegister &&
					<RegisterLogin />
				}

				{ showTickets &&
					<Tickets />
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		requestedAccountData: state.user.requestedAccountData,
		accountData: state.user.accountData
	}
}

export default connect( mapStateToProps )( Home )
